import React from 'react';

import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import { Divider } from 'uiToolkitV1/Divider';

import { SecondaryPanelHeader as PluginPanelHeader } from '../../Components/SectionHeaders';
import { closeRealignPanel } from '../../krDrawerSecondaryPanelSlice';
import { PluginPanelContent } from './PluginPanelContent';

export const CreatePluginMetricPanel = () => {
  const dispatch = useDispatch();
  const onCollapse = () => {
    dispatch(closeRealignPanel());
  };

  return (
    <Flex backgroundColor="#FFFFFF" h="100%" flexDirection="column">
      <PluginPanelHeader headerText="New Custom Metric" onCollapse={onCollapse} />
      <Divider sx={{ borderColor: '#CFD7DF' }} />
      <PluginPanelContent />
    </Flex>
  );
};
